import { render, staticRenderFns } from "./AssignedAgentsModal.vue?vue&type=template&id=ba08e5c4&"
import script from "./AssignedAgentsModal.vue?vue&type=script&lang=js&"
export * from "./AssignedAgentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba08e5c4')) {
      api.createRecord('ba08e5c4', component.options)
    } else {
      api.reload('ba08e5c4', component.options)
    }
    module.hot.accept("./AssignedAgentsModal.vue?vue&type=template&id=ba08e5c4&", function () {
      api.rerender('ba08e5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/AssignedAgentsModal.vue"
export default component.exports